/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.route = require('./helpers/route');
window.Vue = require('vue');

/*import 'babel-polyfill'*/

require('./bootstrap');
require('select2');
require('./combodate');
require('bootstrap-select');
require('bootstrap-colorpicker')
const VueInputMask = require('vue-inputmask').default

var StarRating = require('vue-star-rating');

axios.defaults.baseURL = window.baseUrl + '/api/';

import Autocomplete from 'v-autocomplete'
import BackToTop from 'vue-backtotop'
import Affix  from 'vue-affix';
import MaskedInput from 'vue-text-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from './store/index'

import VueLazyload from 'vue-lazyload'

Vue.use(VueInputMask)
Vue.use(require('vue-clipboard2'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
let VueValidation = require('vee-validate');
let VueValidationIt = require('vee-validate/dist/locale/it');
let VueScrollactive = require('vue-scrollactive');

Vue.use(require('bootstrap-vue'));

//import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueLazyload);
Vue.use(Affix);
Vue.use(VueScrollactive);
Vue.use(BackToTop);
Vue.use(VueValidation, {
    events: 'change',
    locale: 'it',
    dictionary: {
        it: VueValidationIt
    }
});

Vue.use(Autocomplete);
Vue.use(VueGoogleMaps, {
    load: {
        key: window.googleMapsAPI,
        libraries: 'places'
    }
});


// Function for using laravel validation with vee-validate
Vue.prototype.$setErrorsFromResponse = function (errorResponse, formName = null) {
    // only allow this function to be run if the validator exists
    if (!this.hasOwnProperty('$validator')) {
        return;
    }

    // clear errors
    this.$validator.errors.clear();

    // check if errors exist
    if (!errorResponse.hasOwnProperty('errors')) {
        return;
    }

    let errorFields = Object.keys(errorResponse.errors);

    // insert laravel errors
    errorFields.map(field => {
        let errorString = errorResponse.errors[field].join(', ');
        if (formName) {
            this.$validator.errors.add(formName + '.' + field, errorString);
        }
        else {
            this.$validator.errors.add(field, errorString);
        }
    });
};

$.fn.select2.defaults.set( "theme", "bootstrap" );

Vue.mixin({
    data() {
        const commonMonths = [
            {value: 0, name: 'Gennaio', utc: 1},
            {value: 1, name: 'Febbraio', utc: 2},
            {value: 2, name: 'Marzo', utc: 3},
            {value: 3, name: 'Aprile', utc: 4},
            {value: 4, name: 'Maggio', utc: 5},
            {value: 5, name: 'Giugno', utc: 6},
            {value: 6, name: 'Luglio', utc: 7},
            {value: 7, name: 'Agosto', utc: 8},
            {value: 8, name: 'Settembre', utc: 9},
            {value: 9, name: 'Ottobre', utc: 10},
            {value: 10, name: 'Novembre', utc: 11},
            {value: 11, name: 'Dicembre', utc: 12}
        ]

        const commonFutureMonths = []
        const actualMonth = new Date().getMonth()
        commonMonths.forEach((mData) => {
            if (mData.value >= actualMonth) {
                commonFutureMonths.push(mData)
            }
        })


        return {
            orderedCommonWeekDays: [
                {value: 1, long: 'Lunedì', short: 'LUN'},
                {value: 2, long: 'Martedì', short: 'MAR'},
                {value: 3, long: 'Mercoledì', short: 'MER'},
                {value: 4, long: 'Giovedì', short: 'GIO'},
                {value: 5, long: 'Venerdì', short: 'VEN'},
                {value: 6, long: 'Sabato', short: 'SAB'},
                {value: 0, long: 'Domenica', short: 'DOM'},
            ],            
            commonWeekDays: [
                {value: 0, long: 'Domenica', short: 'DOM'},
                {value: 1, long: 'Lunedì', short: 'LUN'},
                {value: 2, long: 'Martedì', short: 'MAR'},
                {value: 3, long: 'Mercoledì', short: 'MER'},
                {value: 4, long: 'Giovedì', short: 'GIO'},
                {value: 5, long: 'Venerdì', short: 'VEN'},
                {value: 6, long: 'Sabato', short: 'SAB'}
            ],
            commonMonths,
            commonFutureMonths
        }
    },
    methods: {
        scrollOnTop() {
            $('html,body').animate({scrollTop: 0}, 'fast')
            $('#app .page-content').animate({scrollTop: 0}, 'fast')
        },
        handleError(error) {
            const data = error.data;
            let message = '';
            if (data.hasOwnProperty('errors')) {
                message += '<ul class="list-unstyled mb-0">';
                for (let key in data.errors) {
                    message += `<li><span class="text-capitalize">${key}</span>: ${data.errors[key]}</li>`;
                }
                message += '</ul>';
            } else if (data.hasOwnProperty('error')) {
                message = data.error;
            } else {
                message = 'Qualcosa &egrave; andato storto!';
            }
            window.alerts.error(message);
        },
        loadAllCountries() {
            return $.ajax(route('countries.search'), {
                type: "get",
                dataType: "json"
            })
        },
        loadAllPhonePrefixes() {
            return $.ajax(route('phonePrefixes.search'), {
                type: "get",
                dataType: "json"
            })
        },
        loadItalianProvinces() {
            return $.ajax(route('provinces.search'), {
                type: "get",
                dataType: "json"
            })
        },
        loadItalianMunicipalities(provinceId = '') {
            return $.ajax(route('municipalities.search'), {
                type: "get",
                dataType: "json",
                data: {
                    province_id: provinceId
                }
            })
        },
        writeOptionsInSelect($select, key = null, keyText = null, options = [], selectedValue = null, data = [], handleValue, handleText) {
            for (const item of options) {
                if(key == null) {
                    key = 'id'
                }

                if(keyText == null) {
                    keyText = 'id'
                }

                let currentValue = item[key]
                if(typeof(handleValue) == 'function') {
                    currentValue = handleValue(item)
                }

                let currentText = item[keyText]
                if(typeof(handleText) == 'function') {
                    currentText = handleText(item)
                }

                if(typeof(selectedValue) == 'function') {
                    selectedValue = selectedValue(currentValue)
                }

                const option = new Option(currentText, currentValue); 

                if(selectedValue && currentValue == selectedValue) {
                    option.defaultSelected = true;
                }

                const $option = $(option);

                if(data && data.length > 0) {
                    for (const sd of data) {
                        $option.data(sd, item[sd])
                    }
                }

                $select.append($option);
            }
        }
    }
});

/*

*/
/*Vue.component('vue-footer', require('./components/Footer.vue'));*/
Vue.component('masked-input', MaskedInput);
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-map-marker', VueGoogleMaps.Marker);
Vue.component('google-map-infowindow', VueGoogleMaps.InfoWindow);
Vue.component('google-map-cluster', VueGoogleMaps.Cluster);

Vue.component('v-owl-carousel', require('v-owl-carousel'));
Vue.component('sportsclubs', require('./components/SportsClubs.vue'));

Vue.component('course-promotion-container', require('./components/course/CoursePromotionContainer'))
Vue.component('search-orangopack-filters-container', require('./components/orangopack/SearchOrangopackFiltersContainer'));
Vue.component('orangopack-card', require('./components/course/OrangopackCard.vue'));
Vue.component('course-promotion-support-modal', require('./components/company/CoursePromotionSupportModal.vue'));
Vue.component('course-promotion-modal', require('./components/company/CoursePromotionModal.vue'));
Vue.component('course-buyable-promotion-form', require('./components/course/CourseBuyablePromotionForm.vue'));
Vue.component('course-promotion-form', require('./components/company/CoursePromotionForm.vue'));
Vue.component('company-help-form', require('./components/company/CompanyHelpForm.vue'));
Vue.component('company-detail', require('./components/company/Detail.vue'));
Vue.component('registration', require('./components/Registration.vue'));
Vue.component('reservation-register', require('./components/reservation/ReservationRegister.vue'))
Vue.component('reservation-payment-form', require('./components/reservation/ReservationPaymentForm.vue'))
Vue.component('reservation-contact-form', require('./components/reservation/ReservationContactForm.vue'))
Vue.component('reservation-form', require('./components/reservation/ReservationForm.vue'))
Vue.component('reservation-fiscal-file-form', require('./components/reservation/ReservationFiscalFileForm.vue'))
Vue.component('course-sticky-navbar', require('./components/course/CourseStickyNavbar.vue'));
Vue.component('course-notification-form', require('./components/course/CourseNotificationForm.vue'));
Vue.component('course-buyable', require('./components/course/CourseBuyable.vue'));
Vue.component('course-map', require('./components/course/CourseMap.vue'));
Vue.component('gift-cards-container', require('./components/gift/GiftCardsContainer.vue'));
Vue.component('gift-card-modal', require('./components/gift/GiftCardModal.vue'));
Vue.component('gift-course-search-form', require('./components/course/GiftCourseSearchForm.vue'));
Vue.component('gift-search-age-form', require('./components/gift/GiftSearchAgeForm.vue'))
Vue.component('gift-search-municipality-form', require('./components/gift/GiftSearchMunicipalityForm.vue'))
Vue.component('gift-search-sports-form', require('./components/gift/GiftSearchSportsForm.vue'))
Vue.component('gift-items-container', require('./components/gift/GiftItemsContainer.vue'))
Vue.component('user-profile-container', require('./components/user/Profile.vue'));
Vue.component('user-profile', require('./components/user/UserProfile'));
Vue.component('user-profile-companies', require('./components/user/UserCompanies'));
Vue.component('user-profile-company-members', require('./components/user/UserCompanyMembers'));
Vue.component('user-profile-company-member', require('./components/user/UserCompanyMember'));
Vue.component('user-reservations', require('./components/user/Reservations'));
Vue.component('user-profile-purchases', require('./components/user/Purchases'));
Vue.component('checkin-container', require('./components/checkin/CheckinContainer.vue'))
Vue.component('user-register', require('./components/auth/UserRegister.vue'));
Vue.component('user-register-page', require('./components/auth/UserRegister.Page.vue'));
Vue.component('user-login', require('./components/auth/UserLogin.vue'));
Vue.component('user-verify', require('./components/auth/UserVerify.vue'));
Vue.component('go-to-dashboard-button', require('./components/course/GoDashboardButton.vue'));
Vue.component('sportsman', require('./components/reservation/ReservationSportsman.vue'));
Vue.component('search-view', require('./components/search/SearchView.vue'));
Vue.component('search-view-form-container', require('./components/search/SearchViewFormContainer.vue'));
Vue.component('search-view-container', require('./components/search/SearchViewContainer.vue'));
Vue.component('search-navbar', require('./components/search/SearchNavbar.vue'));
Vue.component('search-company-modal', require('./components/search/SearchCompanyModal.vue'));
Vue.component('seo-search-navbar', require('./components/search/SeoSearchNavbar.vue'));
Vue.component('homepage', require('./components/home/Homepage'));
Vue.component('custom-selector', require('./components/shared/CustomSelector'));
Vue.component('cart-tabs', require('./components/cart/CartTabs.vue'));
Vue.component('cart', require('./components/cart/Cart.vue'));

Vue.component('cart-form-container', require('./components/cart/CartFormContainer'))
Vue.component('cart-summary-container', require('./components/cart/CartSummaryContainer'))
Vue.component('voucher-partecipants-container', require('./components/purchases/VoucherPartecipantsContainer'))
Vue.component('friend-form', require('./components/cart/FriendForm.vue'));
Vue.component('payment-form', require('./components/cart/PaymentForm.vue'));
Vue.component('payment-summary', require('./components/cart/PaymentSummary.vue'));
Vue.component('page-clip-loader', require('./components/spinners/PageClipLoader.vue'));
Vue.component('element-clip-loader', require('./components/spinners/ElementClipLoader.vue'));
Vue.component('reservation-google-map', require('./components/reservation/ReservationGoogleMap.vue'));
//Vue.component('show-course', require('./components/course/ShowCourse.vue'));

Vue.component('about-us', require('./components/AboutUs.vue'));
Vue.component('contracts-modal', require('./components/PaymentContracts/ContractsModal.vue'));
Vue.component('fiscal-file-form', require('./components/cart/FiscalFileForm.vue'));
Vue.component('login-modal', require('./components/cart/LoginModal.vue'));
Vue.component('home-searchbar', require('./components/search/HomeSearchbar.vue'));
//Vue.component('homepage-scroller', require('./components/home/HomePageScroller.vue'));

Vue.component('widget-search-generation-form', require('./components/widgets/WidgetSearchGenerationForm.vue'));
Vue.component('widget-disabilities-container', require('./components/widgets/WidgetDisabilitiesContainer.vue'))
Vue.component('widget-pagolight', require('./components/widgets/WidgetPagoLight.vue'))

//Dashboard components
Vue.component('dashboard-banner-demo', require('./components/company/dashboard/DashboardBannerDemo.vue'));
Vue.component('dashboard', require('./components/company/dashboard/Dashboard.vue'));
Vue.component('company-sidebar', require('./components/company/dashboard/Sidebar'));
Vue.component('company-reservation-response-form', require('./components/company/dashboard/partials/ReservationResponseForm'))
Vue.component('marketing-services', require('./components/company/dashboard/partials/MarketingServices'));
Vue.component('my-courses', require('./components/company/dashboard/MyCourses'));
Vue.component('my-course-item', require('./components/company/dashboard/partials/MyCourseItem'));
Vue.component('my-promoted-course-item', require('./components/company/dashboard/partials/MyPromotedCourseItem'));
Vue.component('reservations', require('./components/company/dashboard/Reservations'));
Vue.component('requests', require('./components/company/dashboard/Requests'));
Vue.component('company-profile', require('./components/company/dashboard/Profile'));
Vue.component('company-widget', require('./components/company/dashboard/Widget'));
/*Vue.component('gift-contracts', require('./components/company/GiftContracts.vue'));*/
Vue.component('company-voucher-form', require('./components/company/CompanyVoucherForm.vue'));
Vue.component('sport-carousel', require('./components/sports/SportCarousel'));
Vue.component('sport-course-card', require('./components/sports/SportCourseCard'));
Vue.component('search-orangopacks-container', require('./components/course/SearchOrangopacksContainer.vue'));
Vue.component('course-related-invitation-item', require('./components/course/SearchOrangopacksContainer.vue'));
Vue.component('invitation-course-form', require('./components/course/InvitationCourseForm.vue'));
Vue.component('course-star-rating', require('./components/course/CourseStarRating'));
Vue.component('course-reviews', require('./components/course/CourseReviews'));
Vue.component('course-review-item', require('./components/course/CourseReviewItem'));
Vue.component('course-container', require('./components/course/CourseContainer'));
Vue.component('review-notification-form', require('./components/course/ReviewNotificationForm'));
Vue.component('seo-age-container', require('./components/seo/SeoAgeContainer'));
Vue.component('seo-company-card-container', require('./components/seo/SeoCompanyCardContainer'));

Vue.component('search-view-result-course-container', require('./components/search/SearchViewResultCourseContainer'));
/*Vue.component('courses-cards-group', require('./components/course/CoursesCardsGroup'));*/
Vue.component('course-card-item', require('./components/course/CourseCardItem'));

//summer camps
Vue.component('summer-camp-signin-container', () => import('./components/summer-camps/SummerCampSigninContainer'))
Vue.component('summer-camp-purchase-summary-container', () => import('./components/summer-camps/SummerCampPurchaseSummaryContainer'))
Vue.component('summer-camp-reservation-cart-container', () => import('./components/summer-camps/SummerCampReservationCartContainer'))
Vue.component('summer-camp-publish-button', () => import('./components/summer-camps/SummerCampPublishButton'))
Vue.component('summer-camp-start', () => import('./components/summer-camps/SummerCampStart'));
Vue.component('summer-camp-notification-form', () => import('./components/summer-camps/SummerCampNotificationForm.vue'));
Vue.component('show-summer-camp', () => import('./components/summer-camps/ShowSummerCamp.vue'));
Vue.component('summer-camp-product-show', () => import('./components/summer-camps/SummerCampProductShow.vue'));
Vue.component('summer-camp-search-view-container', () => import('./components/summer-camps/SummerCampSearchViewContainer.vue'))

Vue.component('events-by-distance-container', () => import('./components/events/EventsByDistanceContainer'))
Vue.component('event-payment-promotion-container', () => import('./components/events/EventPaymentPromotionContainer'))
Vue.component('event-map-container', () => import('./components/events/EventMap'))
Vue.component('events-geolocation-widget-container', () => import('./components/events/EventsGeolocationWidgetContainer'))
Vue.component('my-events', () => import('./components/company/dashboard/events/MyEvents.vue'));
Vue.component('event-reservations-container', () => import('./components/company/dashboard/events/EventReservationsContainer'))
Vue.component('event-publish-form-container', () => import('./components/events/EventPublishFormContainer'))
Vue.component('event-create-form', () => import('./components/events/EventCreateForm'))
Vue.component('event-edit-form-container', () => import('./components/events/EventEditFormContainer'))
Vue.component('event-edit-navbar', () => import('./components/events/EventEditNavbar'))
Vue.component('event-reservation-contact-form', () => import('./components/events/EventReservationContactForm'))
Vue.component('my-summer-camps', () => import('./components/company/dashboard/summer_camps/MySummerCamps.vue'));
Vue.component('my-summer-camp-item', () => import('./components/company/dashboard/summer_camps/MySummerCampItem.vue'));

Vue.component('summer-camps-seo-card', () => import('./components/seo/summer_camps/SummerCampsSeoCard.vue'));
Vue.component('summer-camps-seo-search-form', () => import('./components/seo/summer_camps/SummerCampsSeoSearchForm'));
Vue.component('summer-camps-results-container', () => import('./components/seo/summer_camps/SummerCampsResultsContainer'));
Vue.component('summer-camps-results-seo-card', () => import('./components/seo/summer_camps/SummerCampsResultsSeoCard'));
Vue.component('summer-camps-results-seo-card-short', () => import('./components/seo/summer_camps/SummerCampsResultsSeoCardShort'));

// Federation
Vue.component('fed-map-container', require('./components/federation/FedMapContainer'));

// Hubspot
Vue.component('hubspot-newsletter', require('./components/hubspot/HubspotNewsletter'))

// Events
Vue.component('search-events-container', () => import('./components/events/SearchEventsContainer'));
Vue.component('search-events-filters-container', () => import('./components/events/SearchEventsFiltersContainer'));
Vue.component('search-events-form-container', () => import('./components/events/SearchEventsFormContainer'));
Vue.component('event-contact-form', () => import('./components/events/EventContactForm'));
Vue.component('event-ticket-booking-modal', () => import('./components/events/EventTicketBooking'));
Vue.component('event-ticket-checkout', () => import('./components/events/EventTicketCheckout'));
Vue.component('event-ticket-checkout-container', () => import('./components/events/EventTicketCheckoutContainer'));
Vue.component('event-ticket-checkin', () => import('./components/events/EventTicketCheckin'));
Vue.component('event-card', () => import('./components/events/EventCard'));

// Save Search
Vue.component('save-search-form', require('./components/search/SaveSearchForm'));

//landings
Vue.component('landing-show', require('./components/landings/LandingShow'));
Vue.component('company-card-mini', require('./components/company/CompanyCardMini'));

require('./vue-filters');
require('./vue-directives');

Vue.prototype.$bus = new Vue();

const app = new Vue({
    store,
    el: '#app',
    data() {
        return {
            user: {
                cart_elements: 0
            }
        }
    },
    mounted() {
        let self = this;
        this.user.cart_elements = window.cart_elements;

        this.$bus.$on('increment-cart', function (quantity) {
            self.user.cart_elements += quantity;
        });
    },
});

require('./fancybox');
window.Dropzone = require('dropzone');
//require('bootstrap-select');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js